<div class="link-example-box">
  <ng-container #container></ng-container>

  <button *ngIf="example"
          type="button"
          class="example-link-btn"
          aria-haspopup="dialog"
          [attr.aria-label]="'예문 보기: ' + example.example_t"
          (click)="openExample($event)">
    <span class="example-txt"
          [innerHTML]="showLongVowels ? (example.example_t | rmSlash | resize) : (example.example_t | rmSlash | rmLongVowel | resize)"></span>
  </button>
</div>
